

































































import {Component, Vue, Watch} from 'vue-property-decorator';
import MenuItemComponent from '@/components/layouts/base/MenuItemComponent.vue';
import Affair from '@/models/Affair';
import {getAffairs, getCurrentAffair, setCurrentAffair} from '@/repositories/api/AffairApiRepository';
import ApiResponseOld from '@/interfaces/ApiResponseOld';
@Component({
  components: {MenuItemComponent}
})
export default class AffairComponent extends Vue {
  currentAffair: Affair|null = null;
  affairs: Affair[] = [];
  search: String = "";
  loadingCurrentAffair = false;
  loadingAffairs = false;

  // get computedStations() {
  //   return this.computedAffairs.reduce(function (accumulator, affair) {
  //     let station = affair.station;
  //     if (!(<any>accumulator)[station]) {
  //       (<any>accumulator)[station] = [];
  //     }
  //     (<any>accumulator)[station].push(affair);
  //     return accumulator;
  //   }, {});
  // }

  get computedAffairs() {
    let result:Affair[] = [];

    if(this.affairs){
      result = this.affairs.filter(affair => {
        return (
          affair.affairName
            .toLowerCase()
            .match(this.search.toLocaleLowerCase()) ||
          affair.affairNumber
            .toString()
            .toLowerCase()
            .match(this.search.toLocaleLowerCase()) ||
          (affair.station &&
            affair.station.toLowerCase().match(this.search.toLocaleLowerCase()))
        );
      });
    }

    return result;
  }

  async mounted() {
    await this.loadCurrentAffair();
    await this.loadAffairs();
  }

  private async loadCurrentAffair() {
    this.loadingCurrentAffair = true;
    let response: ApiResponseOld|null = null;

    try {
      response = await getCurrentAffair();
    } catch (e) {
      console.log(e);
    }

    if(null !== response && response.error === 'success'){
      this.currentAffair = response.data as Affair;
    }

    this.loadingCurrentAffair = false;
  }

  private async loadAffairs() {
    this.loadingAffairs = true;
    let response: ApiResponseOld|null = null;

    try {
      response = await getAffairs();
    } catch (e) {
      console.log(e);
    }

    if(null !== response && response.error === 'success'){
      this.affairs = response.data as Affair[];
    }

    this.loadingAffairs = false;
  }

  @Watch('currentAffair')
  onCurrentAffair(newAffair: Affair, oldAffair: Affair)
  {
    if((newAffair && oldAffair) && oldAffair.affairNumber !== newAffair.affairNumber){
      this.setCurrentAffair(newAffair.affairNumber);
    }
  }

  private async setCurrentAffair(affairNumber: number) {
    this.loadingCurrentAffair = true;
    let response: ApiResponseOld|null = null;

    try {
      response = await setCurrentAffair(affairNumber);
    } catch (e) {
      console.log(e);
    }

    if(null !== response && response.error === 'success'){
      this.currentAffair = response.data as Affair;
    }

    this.loadingCurrentAffair = false;
  }
}
